import httpService from "app/services/httpService";
import config from "../../../src/config.json";
import * as signalR from "@microsoft/signalr";
import { getToken, verifyAndExtractName } from "helper";

const apiUrl = config.apiUrl;

let connection = null;
const startConnection = async () => {
  const name = verifyAndExtractName();
  const token = await getToken();

  if (!name || !token) {
    // console.warn(
    //   "Missing username or token, cannot establish SignalR connection."
    // );
    return;
  }

  if (connection && connection.state === signalR.HubConnectionState.Connected) {
    // console.warn("SignalR connection already established.");
    return;
  }

  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${apiUrl}/notificationHub?username=${name}`, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => token,
    })
    // .configureLogging(signalR.LogLevel.None)
    .withAutomaticReconnect()
    .build();

  try {
    await connection.start();
    console.log("✅ SignalR Connected!");
  } catch (err) {
    // console.error("❌ SignalR Connection Failed:", err);
    setTimeout(startConnection, 5000);
  }
};

const stopConnection = async () => {
  if (connection) {
    // console.log("🛑 Stopping SignalR connection...");
    await connection.stop();
    connection = null;
  }
};

// const onCancelNotificationReceived = (callback) => {
//   connection?.on("cancel_notification", (message) => {
//     callback(message);
//   });
// };

// const onCancelNotificationSeen = (callback) => {
//   connection?.on("notification-seen", (message) => {
//     callback(message);
//   });
// };

// const onNotificationStatus = (callback) => {
//   connection?.on("notification-status", (message) => {
//     callback(message);
//   });
// };
const onCancelNotificationReceived = (callback) => {
  connection?.on("cancel_notification", (message) => {
    callback(message);
  });
};
const onHoldNotificationReceived = (callback) => {
  connection?.on("hold_notification", (message) => {
    callback(message);
  });
};
const onCancelNotificationSeen = (callback) => {
  connection?.on("notification-seen", (message) => {
    callback(message);
  });
};

const onCancelNotificationStatus = (callback) => {
  connection?.on("multi-notification", (message) => {
    callback(message);
  });
};

const notificationMarkSeen = async (value) => {
  try {
    const url = `${apiUrl}/notification/mark-seen?notificationtype=${value}`;
    const { data } = await httpService.post(url);
    // return data;
  } catch (error) {
    throw error;
  }
};

const notificationStatus = async (value) => {
  try {
    const url = `${apiUrl}/notification/admin-notification-status/${value}`;
    const { data } = await httpService.post(url);
    // return data;
  } catch (error) {
    throw error;
  }
};

export {
  startConnection,
  onCancelNotificationReceived,
  onHoldNotificationReceived,
  onCancelNotificationSeen,
  stopConnection,
  notificationMarkSeen,
  notificationStatus,
  onCancelNotificationStatus,
  connection,
};
